
import { Footer } from "react-dsgov";
import SiteHeader from "../SiteHeader/SiteHeader";
import { Outlet } from "react-router";
import OverlayLoading from "../OverlayLoading/OverlayLoading";
import styles from './Layout.module.scss';
import ChatLogos from "../ChatLogos/ChatLogos";
import { useEffect, useRef, useState } from "react";
import useResizeObserver from "@react-hook/resize-observer";
import usePageChangeNotifier from "../../hooks/usePageChangeNotifier";
import { isPortalInteroperabilidade } from "../../config/portalMode";
import useCatalogoService from "../../hooks/useCatalogoService";



import { useClear, useClearWithMenu } from "../../hooks/useClear";

const Layout : React.FC = () => {
    const clear = useClear();
    const clearWithMenu = useClearWithMenu();
    const portalInteroperabilidade = isPortalInteroperabilidade();
    const catalogoService = useCatalogoService();
    const [temDocumentacoes, setTemDocumentacoes] = useState(false);
    const site = useRef<HTMLDivElement>(null);
    usePageChangeNotifier();

    useEffect(() => {
        catalogoService.getCategoriasDocumentacoes()
            .then(categorias => setTemDocumentacoes(categorias.length > 0))
            .catch(() => setTemDocumentacoes(false));
    }, [catalogoService]);

    const menuLinks = [
        { label: "Sobre o Portal", path: "/sobre" },
        ...(temDocumentacoes ? [{ label: portalInteroperabilidade ? "Manuais" : "Documentações", path: "/docs" }] : []),
        ...(!portalInteroperabilidade ? [{ label: "Catálogo de Componentes", path: "/catalogo-componentes" }] : []),
        { label: "Catálogo de APIs", path: "/catalogo-apis" },
    ];

    useResizeObserver(site, (entry) => {
        const dimensions = {
            width: entry.contentRect.width,
            height: entry.contentRect.height
        };
        if (window.parent && window.parent !== window) {
            window.parent.postMessage({ type: 'redimensionar-frame', ...dimensions }, '*');
        }
    });

    return (
        <div ref={site}>
            {!clear && <SiteHeader showDocumentacoes={temDocumentacoes} />}
            {clearWithMenu && (
                <nav className={styles.menuLimpo} aria-label="Navegação principal">
                    {menuLinks.map((link) => (
                        <a key={link.path} href={`${link.path}?clear=true-with-menu`}>
                            {link.label}
                        </a>
                    ))}
                </nav>
            )}
            <div className={styles.conteudo}>
                <Outlet />
            </div>
            {!clear && (
                <Footer urlLogo="/logo-govbr.svg" />
            )}
            {!clear && <ChatLogos />}
            <OverlayLoading />
        </div>
    );
}

export default Layout;